import { AppRegistry } from "react-native";
import { App } from "./App";
import { resolveApiBaseUrl } from "./config";
import "./styles.css";

AppRegistry.registerComponent("root", () => App);
AppRegistry.runApplication("root", {
  rootTag: document.getElementById("root")!,
  initialProps: {
    baseUrl: resolveApiBaseUrl(import.meta.env.VITE_API_BASE_URL, import.meta.env.PROD),
  },
});
